export default __webpack_public_path__ + "static/media/concentracao-colheita.18618e13.svg";